import { Component, OnInit } from '@angular/core';
import * as jwt_decode from 'jwt-decode';
import {CommonUtil} from '../../../../utils/common.util';

@Component({
  selector: 'app-enquiry-sidebar',
  templateUrl: './enquiry-sidebar.component.html',
  styleUrls: ['./enquiry-sidebar.scss']
})
export class EnquirySidebarComponent implements OnInit {

  public CURRENT_YEAR = CommonUtil.getCurrentAcademicYear();

  public userName = '';

  public pendingCount = '0';

  constructor() {
    if (localStorage.getItem('pendingCount')) {
      this.pendingCount = localStorage.getItem('pendingCount');
    }
  }

  ngOnInit() {
    const token = localStorage.getItem('userToken');
    if (token !== null) {
      const userData = jwt_decode(token);
      this.userName = userData.name;
    }
    // active class remove class
    (<any>$('.side-menu-root > a').click(function() {
      (<any>$('.side-menu-root.active')).removeClass('active');
      (<any>$(this).closest('li')).addClass('active');
    }));
  }

}
